import { observable } from "mobx";
import { Type } from "class-transformer";
import SingleChargeDetailResponse from "./singleChargeDetailResponse";
import SingleChargeOrderDetailResponse from "./singleChargeOrderDetailResponse";
import SingleChargeVehicleRegisterVehicleDetailResponse from "./singleChargeVehicleRegisterVehicleDetailResponse";
import SingleChargeNotificationPreferencesResponse from "./singleChargeNotificationPreferencesResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class GetSingleChargeDetailResponse {
  @observable
  @Type(() => SingleChargeDetailResponse)
  chargeDetail!: SingleChargeDetailResponse;

  @observable
  @Type(() => SingleChargeOrderDetailResponse)
  chargeOrderDetail!: SingleChargeOrderDetailResponse;

  @observable
  @Type(() => SingleChargeVehicleRegisterVehicleDetailResponse)
  vehicleRegisterVehicleDetail?: SingleChargeVehicleRegisterVehicleDetailResponse;

  @observable
  @Type(() => SingleChargeNotificationPreferencesResponse)
  notificationPreferences!: SingleChargeNotificationPreferencesResponse;
}
